<template>
<v-dialog
    v-model="dialog"
    max-width="600"
    @keydown.esc="onEscape"
>
    <v-card>
        <v-card-title>{{title}}</v-card-title>
        <v-card-text
            
        >
            <div
                v-html="text"
            />

            <v-text-field
                v-if="text_to_confirm != null"
                :label="text_to_confirm_message"
                hide-details="auto"
                v-model="typed_message"
                autocomplete="off"
            ></v-text-field>
                

        </v-card-text>
        
        <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
            v-for="(action, index) in actions"
            :key="index"
            :color="action_color(index)"
            text
            @click="onAction(action)"
            :disabled="isDisabled(index)"
        >
        {{action.text}}
        </v-btn>
    </v-card-actions>

    </v-card>

</v-dialog>
</template>

<script>
const Validate = require('@/js/validate.js');
var Preconditions = require('@/js/Preconditions.js'); 

export default {

    data() {
        return {
            dialog: false,
            
            title: '',
            text: '',
            after_alert: null,
            actions: [],

            text_to_confirm_message: null,
            text_to_confirm: null,
            typed_message: null,
        }
    },

    created () {
        this.$event_bus.$on('confirm', this.showDialog);
    },

    beforeDestroy () {
        this.$event_bus.$off('confirm',this.showDialog);
    },

    methods: {

        showDialog(params) 
        {
            this.title = params.title == null ? 'Alert' : params.title;
            this.text = params.text;
            this.after_confirm = params.after_confirm;
            this.actions = params.actions;
            this.text_to_confirm_message = params.text_to_confirm_message;
            this.text_to_confirm = params.text_to_confirm;
            this.typed_message = null;

            this.dialog = true;
        },

        action_color(index)
        {
            if ( index == this.actions.length -1 ) 
                return 'primary darken-1';
            
            return null;
        },

        onAction(action) {
            this.dialog = false;

            if ( this.after_confirm != null && action.value != null )
            {
                this.after_confirm(action.value);
            }
        },

        onEscape()
        {
            this.after_confirm(this.actions[0].value);
        },

        isDisabled(index)
        {
            if ( index != this.actions.length -1 ) 
                return false;

            if ( this.confirm_enabled )
                return false;

            return true;
        },
    },

    computed: {
        confirm_enabled() 
        {
            if ( this.text_to_confirm == null ) 
                return true; 

            let msg = ''+this.typed_message;
            msg = msg.trim();
            msg = msg.toLowerCase();

            return msg == this.text_to_confirm.toLowerCase();
        }
    },
}
</script>

<style lang="scss" scoped>
</style>